import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-indicator",
  "use": "icon-indicator-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-indicator\"><path d=\"M840 259.456l-167.372 167.26 164.09 148.6L812.4 638 258 636.154V908h-72V152h72v46h556.526zM258 270v294.152l460.784 1.536L596.2 454.676l-1.282-52.132L727.556 270H258z\" p-id=\"3947\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol